module.exports = __webpack_public_path__ + "img/soccer_player.6f632ae9.svg";